export const OFFER = {
  nickname: 'PRODUCTS.OFFER.shortname',
  isHidden: true,
  icon:'offer'
};
